import type { FC } from 'react';
import type { IconProps } from '../Icon';

export const ArrowDownMenu: FC<IconProps> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    height={24}
    width={24}
    strokeWidth={8}
  >
    <g fill="none" stroke={color}>
      <path d="M4.196,26.098l43.804,43.804l43.804,-43.804" />
    </g>
  </svg>
);
